import { IAppLoaderStorage } from '../infrastructure/types/utils/storage-types';
import {
  IAuthorizationService,
  RegistrationGoal,
} from '../infrastructure/types/features/auth/auth-types';
import { CoreRoot } from './core-logic/CoreRoot';
import { UIRoot } from './ui-logic/UiRoot';
import { AppStorage } from '../infrastructure/storage/app-storage';
import { AuthorizationService } from '../infrastructure/utils/auth/authorization-service';
import { NavigationService } from '../infrastructure/utils/navigation/navigation-service';
import { AdaptiveService } from '../infrastructure/utils/adaptive/adaptive-service';
import { UiLogicModules } from '../infrastructure/types/models/UiLogicModules';
import { CoreLogicModules } from '../infrastructure/types/models/CoreLogicModules';
import { IAppLoaderNavigationService } from '../infrastructure/types/features/navigation/navigation-types';
import { IAdaptiveService } from '../infrastructure/types/features/adaptive/adaptive-types';
import { MetrikaService } from '../../shared/infrastructure/utils/counters/metrika-service';
import type { IMetrikaService } from '../../shared/infrastructure/types/common/metrika-types';

class AppLoaderLogicInitializer {
  private coreLogic?: CoreLogicModules;
  private uiLogic?: UiLogicModules;
  private appStorage?: IAppLoaderStorage;
  private authorizationService?: IAuthorizationService;
  private navigationService?: IAppLoaderNavigationService;
  private adaptiveService?: IAdaptiveService;
  private metrikaService?: IMetrikaService<RegistrationGoal>;

  initLogic() {
    this.initServices();
    const coreRoot = new CoreRoot(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.authorizationService!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.navigationService!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.metrikaService!,
    );
    const uiRoot = new UIRoot(
      coreRoot,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.navigationService!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.appStorage!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      this.adaptiveService!,
    );

    coreRoot.authorizationModule.loadProductConfig();

    this.coreLogic = this.getCoreLogic(coreRoot);
    this.uiLogic = this.getUILogic(coreRoot, uiRoot);
  }

  get logic(): { ui: UiLogicModules } {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return { ui: this.uiLogic! };
  }

  private initServices() {
    this.appStorage = new AppStorage();
    this.authorizationService = new AuthorizationService(this.appStorage);
    this.navigationService = new NavigationService();
    this.adaptiveService = new AdaptiveService();
    this.metrikaService = new MetrikaService<RegistrationGoal>();
  }

  private getCoreLogic(coreRoot: CoreRoot): CoreLogicModules {
    return {
      coreRoot: coreRoot,
    };
  }

  private getUILogic(coreRoot: CoreRoot, uiRoot: UIRoot): UiLogicModules {
    return {
      uiRoot: uiRoot,
      routingModule: uiRoot.routingModule,
      authorizationUiModule: uiRoot.authorizationUiModule,
      adaptiveUIModule: uiRoot.adaptiveUIModule,
    };
  }

  private get logicIsInitialized(): boolean {
    return this.coreLogic !== undefined && this.uiLogic !== undefined;
  }
}

const appLoaderLogicInitializer = new AppLoaderLogicInitializer();

export { appLoaderLogicInitializer };
